const getShortName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
  const [firstNameChar] = (firstName && Array.from(firstName.trim())) || []
  const [lastNameChar] = (lastName && Array.from(lastName.trim())) || []

  if (firstNameChar && lastNameChar) return firstNameChar + lastNameChar

  if (firstNameChar) return firstNameChar

  if (lastNameChar) return lastNameChar

  return "UU"
}

export { getShortName }
